<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn padbtn">
          <div class="col-12 col-md-6 col-xl-4">
            <label>{{ $t('common_words.farm') }} *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required shadow-sm filter-farm"
              size="large"
              v-model="farm"
              @change="clearView"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-md-6 col-xl-4">
            <label class="label-primary">{{
              $t('common_words.search_by_date')
            }}</label>
            <el-date-picker
              v-if="renderComponent"
              v-model="rangeDate"
              type="daterange"
              @change="clearView"
              :start-placeholder="$t('common_words.initial_date')"
              :end-placeholder="$t('common_words.final_date')"
              :clearable="false"
              :picker-options="pickerOptions"
              default-value="2010-10-01"
            >
            </el-date-picker>
          </div>
          <div class="col-2">
            <label class="label-primary" style="color: transparent">a</label
            ><br />
            <l-button wide type="info" class="btn-filter" @click="filterData">
              {{ $t('common_words.filter') }}
            </l-button>
          </div>
        </div>
      </card>
    </div>
    <template v-if="viewData">
      <div class="col-12 mt-4">
        <card class="custom-shadow-card-header custom-table-responsive">
          <div class="mt-4">
            <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
              <div class="table-responsive">
                <table
                  class="table table-striped table-bordered table table-journals not-last-td"
                >
                  <thead>
                    <tr class="cusmtom-thead-color">
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                        rowspan="2"
                        style="
                          width: 250px !important;
                          min-width: 250px !important;
                        "
                      >
                        {{ $t('fertilization.fertilizer') }}
                      </th>
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                        rowspan="2"
                        style="
                          width: 150px !important;
                          min-width: 150px !important;
                        "
                      >
                        {{ $t('common_words.description') }}
                      </th>
                      <th
                        v-for="(i, index) in getAllIndex()"
                        :key="index"
                        scope="col"
                        class="text-center p-3 custom-header-label"
                        :colspan="i.spaces"
                        style="border-bottom: 1px solid !important"
                      >
                        {{ $t('production.bundle_quantity_cycle') }}
                        {{ i.year }}
                      </th>
                      <th
                        scope="col"
                        class="text-center p-3 custom-header-label"
                        rowspan="2"
                        style="
                          width: 150px !important;
                          min-width: 150px !important;
                        "
                      >
                        {{ $t('common_words.total') }}
                      </th>
                    </tr>
                    <tr class="cusmtom-thead-color">
                      <th
                        v-for="(column, index) in fertilization_cycles"
                        :key="index"
                        class="text-center p-3 custom-header-label"
                        style="min-width: 100px !important"
                      >
                        {{ column.number_cycles }}
                      </th>
                    </tr>
                    <!-- <th scope="col" class="text-center p-3 custom-header-label" rowspan="2" style="width: 150px !important; min-width: 150px !important;">
                        Total
                    </th> -->
                  </thead>
                  <tbody>
                    <tr v-for="i in tableData.length * 2" :key="i">
                      <td v-if="(i - 1) % 2 == 0" rowspan="2">
                        <span v-if="tableData[Math.round((i - 1) / 2 - 0.1)]">
                          {{
                            tableData[Math.round((i - 1) / 2 - 0.1)].fertilizer
                          }}
                        </span>
                      </td>
                      <td>
                        <span v-if="(i - 1) % 2 == 0">{{
                          $t('common_words.budgeted')
                        }}</span>
                        <span v-else>{{ $t('common_words.applied') }}</span>
                      </td>
                      <td
                        v-for="column in cycleColumns"
                        :key="column.id"
                        class="text-center"
                      >
                        <span v-if="(i - 1) % 2 == 0">
                          <span
                            v-if="
                              tableData[Math.round((i - 1) / 2 - 0.1)] &&
                              tableData[Math.round((i - 1) / 2 - 0.1)][
                                'cycle' + column.id
                              ]
                            "
                          >
                            {{
                              formatMoney(
                                tableData[Math.round((i - 1) / 2 - 0.1)][
                                  'cycle' + column.id
                                ].np_budgeted
                              )
                            }}
                          </span>
                        </span>
                        <span v-else>
                          <span
                            v-if="
                              tableData[Math.round((i - 1) / 2 - 0.1)] &&
                              tableData[Math.round((i - 1) / 2 - 0.1)][
                                'cycle' + column.id
                              ]
                            "
                          >
                            {{
                              formatMoney(
                                tableData[Math.round((i - 1) / 2 - 0.1)][
                                  'cycle' + column.id
                                ].np_applied
                              )
                            }}
                          </span>
                        </span>
                      </td>
                      <td class="text-center">
                        <span v-if="(i - 1) % 2 == 0">
                          <span v-if="tableData[Math.round((i - 1) / 2 - 0.1)]">
                            {{
                              formatMoney(
                                tableData[Math.round((i - 1) / 2 - 0.1)]
                                  .total_budgeted
                              )
                            }}
                          </span>
                        </span>
                        <span v-else>
                          <span v-if="tableData[Math.round((i - 1) / 2 - 0.1)]">
                            {{
                              formatMoney(
                                tableData[Math.round((i - 1) / 2 - 0.1)]
                                  .total_applied
                              )
                            }}
                          </span>
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div v-else>
              <br />
              <h5 class="text-muted text-center">
                {{ $t('common_words.no_permissions') }}
              </h5>
            </div>
          </div>
        </card>
      </div>
      <div class="col-12 mt-4">
        <card class="custom-shadow-card-header">
          <div v-if="isIndex()">
            <div class="col-sm-12">
              <el-table
                stripe
                style="width: 100%"
                height="500"
                :data="tableViewData"
                :span-method="arraySpanMethod"
                :cell-class-name="tableCellClassName"
                :border="true"
              >
                <el-table-column
                  min-width="150"
                  prop="fertilizer"
                  :label="$t('fertilization.fertilizer')"
                ></el-table-column>
                <el-table-column
                  min-width="100"
                  prop="number_packages"
                  :label="$t('production.bundle_quantity')"
                  :formatter="formatterNumber"
                ></el-table-column>
                <el-table-column
                  min-width="100"
                  prop="number_packages_kg"
                  :label="$t('production.bundle_quantity_unit')"
                  :formatter="formatterNumber"
                ></el-table-column>
                <el-table-column
                  :label="$t('samples.nutrient_contribution_applied')"
                >
                  <el-table-column
                    v-for="column in nutrientColumns"
                    :key="column.label"
                    :prop="column.prop"
                    :label="column.label"
                    :formatter="formatterNumber"
                    min-width="75"
                  >
                  </el-table-column>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions') }}
            </h5>
          </div>
        </card>
      </div>
      <div class="col-md-12">
        <card class="custom-shadow-card-header">
          <span v-if="Object.keys(chartOptions1).length > 0">
            <div class="row">
              <div class="col-12">
                <highcharts :options="chartOptions1"></highcharts>
              </div>
            </div>
          </span>
          <div slot="footer" class="text-left">
            <p class="card-category">
              <em class="fa fa-clock-o"></em>
              {{ $t('common_words.last_update') }}
              {{ currentTime }}
            </p>
          </div>
        </card>
      </div>
      <div class="col-md-12">
        <card class="custom-shadow-card-header">
          <span v-if="Object.keys(chartOptions2).length > 0">
            <div class="row">
              <div class="col-12">
                <highcharts :options="chartOptions2"></highcharts>
              </div>
            </div>
          </span>
          <div slot="footer" class="text-left">
            <p class="card-category">
              <em class="fa fa-clock-o"></em>
              {{ $t('common_words.last_update') }}
              {{ currentTime }}
            </p>
          </div>
        </card>
      </div>
    </template>
  </div>
</template>

<script>
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import mixinDatePicker from 'src/util/mixinDatePicker';
import mixinCharts from 'src/util/mixinCharts';
import SweetAlert from 'src/class/Alerts';
import moment from 'moment';
import { Chart } from 'highcharts-vue';
import Highcharts from 'highcharts';
import exportingInit from 'highcharts/modules/exporting';
import { StatsCard } from 'src/components/index';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

exportingInit(Highcharts);

export default {
  components: {
    StatsCard,
    highcharts: Chart,
  },

  data() {
    return {
      filter_by: null,
      rangeDate: [
        new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          new Date().getDate() - 1
        ),
        new Date(),
      ],
      year: null,
      initial_cycle: null,
      final_cycle: null,
      farm: null,
      farms: null,
      years: null,
      cycles: null,
      cycleColumns: null,
      tableViewData: [],
      nutrientColumns: [],
      hectares: null,
      index_nutrient_table: null,
      fertilization_cycles: null,
      viewData: false,
      currentTime: moment().format('hh:mm:ss'),
      chartOptions1: {},
      chartOptions2: {},
    };
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    mixinDatePicker,
    mixinCharts,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    clearView() {
      this.viewData = false;
    },

    getAllIndex() {
      let ar = [
        ...new Set(this.fertilization_cycles.map((element) => element.year)),
      ];
      let indicesArray = new Array(ar.length);

      for (let i = 0; i < indicesArray.length; i++) {
        indicesArray[i] = { spaces: 0, year: null };
      }

      for (let i = 0; i < this.fertilization_cycles.length; i++) {
        for (let j = 0; j < ar.length; j++) {
          if (ar[j] === this.fertilization_cycles[i].year) {
            indicesArray[j]['spaces'] += 1;
            if (indicesArray[j]['year'] == null) {
              indicesArray[j]['year'] = this.fertilization_cycles[i].year;
            }
          }
        }
      }

      return indicesArray;
    },

    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex >= this.index_nutrient_table) {
        if (rowIndex === this.index_nutrient_table + 2 && columnIndex === 3) {
          return [1, this.nutrientColumns.length];
        }

        if (columnIndex === 0) {
          return [1, 3];
        } else if (columnIndex === 1 || columnIndex === 2) {
          return [1, 0];
        }
      }
    },

    tableCellClassName({ row, column, rowIndex, columnIndex }) {
      if (rowIndex > this.index_nutrient_table - 1) {
        return 'bold-cell_c';
      }
      return '';
    },

    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      if (rowIndex > this.index_nutrient_table - 1) {
        return 'border-row';
      }
      return '';
    },

    getCycles() {
      this.showHideLoading(true);

      Axios.getMasters('fertilization/compliancereport/' + this.year)
        .then((response) => {
          this.cycles = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    filterData() {
      let data = {};
      data.route = 'fertilization/compliancereport';
      data.farm = this.farm;
      data.init_date = moment(this.rangeDate[0]).format('YYYY-MM-DD');
      data.end_date = moment(this.rangeDate[1]).format('YYYY-MM-DD');

      if (data.farm == null) {
        this.highlightItem('filter-farm');
      } else {
        this.showHideLoading(true);

        Axios.saveMaster(data)
          .then((response) => {
            if (response.data != false) {
              this.tableData = response.data.fertilizer_cycle_table;
              this.fertilization_cycles = response.data.fertilization_cycles;
              this.fillAppliedTable();
              this.hectares = response.data.hectares;
              this.index_nutrient_table = response.data.index_nutrient_table;
              this.tableViewData = response.data.fertilizer_nutrient_table;
              this.fillNutrientTable();
              this.chartOptions1 = this.combinationChart(response.data.chart);
              this.chartOptions2 = this.combinationChart(
                response.data.chart1,
                2,
                true
              );
              this.viewData = true;

              this.showHideLoading();

              setTimeout(() => {
                Object.values(
                  document.getElementsByClassName('custom-td-cr')
                ).forEach((element) => {
                  element.parentElement.parentElement.classList.add(
                    'custom-td-parent-cr'
                  );
                });
              }, 100);
            } else {
              this.showHideLoading();
              SweetAlert.warning(
                i18n.t('sweet_alert.fertilization.no_detailed_info')
              );
            }
          })
          .catch((error) => {
            this.showMessageErrors(error);
          });
      }
    },

    fillAppliedTable() {
      this.showHideLoading(true);

      let cycleColumns = [];

      if (this.fertilization_cycles.length > 0) {
        this.fertilization_cycles.forEach((element) => {
          cycleColumns.push({ id: element.id, label: element.number_cycles });
        });
        this.cycleColumns = cycleColumns;
      }

      this.showHideLoading();
    },

    fillNutrientTable() {
      this.showHideLoading(true);

      let nutrientsColunm = [];
      let index_hectares = 0;

      this.tableViewData.forEach((element, index) => {
        for (const key in element) {
          if (
            key != 'fertilizer' &&
            key != 'number_packages' &&
            key != 'number_packages_kg' &&
            key.substr(-2) != '_b'
          ) {
            let columnsexits = nutrientsColunm.map((colum) => {
              return colum.prop;
            });

            if (!columnsexits.includes(key)) {
              nutrientsColunm.push({ label: key.toUpperCase(), prop: key });
            }
          }
        }

        if (element.fertilizer == 'Total Hectareas') {
          index_hectares = index;
        }

        this.nutrientColumns = nutrientsColunm;
      });

      this.tableViewData[index_hectares][nutrientsColunm[0].prop] =
        this.hectares;

      this.showHideLoading();
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);

      Axios.getMasters('farms/farms/only')
        .then((response) => {
          this.farms = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));

      Axios.getMasters('fertilization/compliancereport/years')
        .then((response) => {
          this.years = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));

      this.showHideLoading();
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('fertilization');
  },

  destroyed() {
    this.deselectedItemOnMenu('fertilization');
  },
};
</script>
